import { useEffect, useState } from "react";
import { useGetPermissionList } from "../fnx/getPermissions";
// Variable global para almacenar los permisos cargados
var cachedPermissions = [];
// Hook para cargar los permisos (usar solo en componentes React)
export var GetNavigationPages = function () {
    var permissionsConfig = [];
    var _a = useState(false), trigger2 = _a[0], setTrigger2 = _a[1];
    var permissionList = useGetPermissionList(trigger2).permissionList;
    useEffect(function () {
        setTrigger2(true);
    }, []);
    useEffect(function () {
        if (permissionList && permissionList.length > 0) {
            cachedPermissions = permissionList;
        }
    }, [permissionList]);
    if (localStorage.getItem("assurehub")) {
        var item = localStorage.getItem("assurehub");
        if (item !== null) {
            // TODO: Implementar lógica correcta basada en el rol del usuario
            permissionsConfig = permissionList;
        }
    }
    return {
        permissionsConfig: permissionsConfig,
    };
};
// Función auxiliar para obtener permisos sin hooks (para usar fuera de componentes)
export var getStoredPermissions = function () {
    return cachedPermissions;
};
//Todo: add the right role to the user
export var hasAuditRole = function () {
    var _a, _b, _c;
    try {
        var storedLogin = localStorage.getItem("assurehub");
        var parsed = storedLogin ? JSON.parse(storedLogin) : {};
        // Buscar en ambas estructuras posibles
        var roles = (_c = (_a = parsed === null || parsed === void 0 ? void 0 : parsed.roles) !== null && _a !== void 0 ? _a : (_b = parsed === null || parsed === void 0 ? void 0 : parsed.user) === null || _b === void 0 ? void 0 : _b.roles) !== null && _c !== void 0 ? _c : [];
        return roles === null || roles === void 0 ? void 0 : roles.some(function (role) {
            return role.name.toLowerCase() === "user" ||
                role.name.toLowerCase() === "fiscal" ||
                role.name.toLowerCase() === "audit";
        });
    }
    catch (error) {
        console.error("Error parsing localStorage in hasAuditRole:", error);
        return false;
    }
};
export var hasPermission = function (tag) {
    var _a, _b, _c;
    try {
        var storedLogin = localStorage.getItem("assurehub");
        var parsed = storedLogin ? JSON.parse(storedLogin) : {};
        // Buscar en ambas estructuras posibles
        var roles = (_c = (_a = parsed === null || parsed === void 0 ? void 0 : parsed.roles) !== null && _a !== void 0 ? _a : (_b = parsed === null || parsed === void 0 ? void 0 : parsed.user) === null || _b === void 0 ? void 0 : _b.roles) !== null && _c !== void 0 ? _c : [];
        var hasAdminRole = roles === null || roles === void 0 ? void 0 : roles.some(function (role) {
            return role.name.toLowerCase() === "administrator" ||
                role.name.toLowerCase() === "admin" ||
                role.name.toLowerCase() === "administrador" ||
                role.name.toLowerCase() === "super admin";
        });
        // Si es admin, tiene todos los permisos
        if (hasAdminRole) {
            return true;
        }
        // Usar permisos cacheados en lugar de llamar al hook
        var permissions = getStoredPermissions();
        // Si no hay permisos en cache, intentar obtenerlos directamente de localStorage
        if (!permissions || permissions.length === 0) {
            var allPermissions = roles === null || roles === void 0 ? void 0 : roles.reduce(function (acc, role) {
                return acc.concat(role.permissions || []);
            }, []);
            return !!(allPermissions === null || allPermissions === void 0 ? void 0 : allPermissions.find(function (i) { return i.name === tag; }));
        }
        return !!(permissions === null || permissions === void 0 ? void 0 : permissions.find(function (i) { return i.name === tag; }));
    }
    catch (error) {
        console.error("Error parsing localStorage in hasPermission:", error);
        return false;
    }
};
